<template>
<div class="ui-notice" style="z-index:9999">
	<notice 
		v-for="notice in notices" 
		:key="notice.name"
		:name="notice.name"
		:type="notice.type"
		:duration="notice.duration"
		:content="notice.content"
		:on-close="notice.onClose"
		:render="notice.render">	
	</notice>
</div>
</template>

<script>
	import Notice from './notice'

	let index = 0

	export default {
		components: {
			Notice
		},
		methods: {
			add (notices) {
				const key = 'ui_notice_' + Date.now() + '_' + (index++)

				let _notice = Object.assign({
					content: '',
                    name: key
				}, notices)

				this.notices.push(_notice)
			},
			close (name) {
				const notices = this.notices
                for (let i = 0; i < notices.length; i++) {
                    if (notices[i].name === name) {
                        this.notices.splice(i, 1)
                        break
                    }
                }
			},
			closeAll () {
                this.notices = []
            }
		},
		data () {
			return {
				notices: []
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/base/notification/notification.vue